import axios from "axios";
import { authHeader } from "@tailormed/common-client/services/auth";
import { getAuthInstance } from "@tailormed/common-client/services/auth";
import { oktaConfig } from "../constant/config";

const SERVER_URL = `${window.location.origin.replace("4800", "1776")}/`;
const API_VERSION_1 = "api/v1/";
const USERS = "users/";

console.log("----------------------------------");
console.log("VERSION:", process.env.REACT_APP_VERSION);
console.log("SERVER_URL:", SERVER_URL);
console.log("----------------------------------");

axios.defaults.withCredentials = true;

const ApiMap = {};
const ApiCallerMap = {};

const CallerType = Object.freeze({
  Generic: 0,
  Auth: 1
});

const Environment = Object.freeze({
  Localhost: "local",
  Mars: "mars",
  TDE: "TDE",
  DEV: "dev"
});

const ApiNames = Object.freeze({
  Login: "Login",
  LoggedUser: "LoggedUser",
  AssistanceProgramSearch: "AssistanceProgramSearch",
  AssistanceProgram: "AssistanceProgram",
  Support: "Support",
  NotificationPreferences: "NotificationPreferences",
  UpdateNotificationPreferences: "UpdateNotificationPreferences"
});

async function axiosWithAuthentication(config) {
  const oktaAuth = getAuthInstance(oktaConfig.redirectUri);
  const token = oktaAuth.getAccessToken();
  config.headers = authHeader(token);
  return axios(config);
}

const fetch =
  (action) =>
  (methodName) =>
  (...params) =>
    new Promise((resolve, reject) => {
      const req = action(...params);
      axios(req)
        .then((res) => resolve(res.data))
        .catch((error) => reject(Object.assign(error, { methodName })));
    });

const add = (name, action, caller = CallerType.Generic) => {
  Object.assign(ApiCallerMap, { [name]: caller });
  Object.assign(ApiMap, { [name]: (...args) => action(...args) });
};

const addAuth = (name, action) => add(name, action, CallerType.Auth);

add(ApiNames.Login, (username, password) => {
  const data = new FormData();
  data.append("username", username);
  data.append("password", password);
  return {
    method: "POST",
    url: `${SERVER_URL}${API_VERSION_1}token/frontend`,
    data
  };
});

addAuth(ApiNames.LoggedUser, (token) => ({
  method: "GET",
  url: `${SERVER_URL}${API_VERSION_1}${USERS}logged-user/frontend`,
  headers: authHeader(token)
}));

addAuth(ApiNames.AssistanceProgramSearch, (token, searchQuery, filters) => {
  const data = {
    searchQuery,
    filters
  };
  return {
    method: "POST",
    url: `${SERVER_URL}${API_VERSION_1}assistanceProgram/apFrontendSearch`,
    headers: authHeader(token),
    data
  };
});

addAuth(ApiNames.AssistanceProgram, (token, id) => {
  return {
    method: "GET",
    url: `${SERVER_URL}${API_VERSION_1}assistancePrograms/${id}`,
    headers: authHeader(token)
  };
});

addAuth(ApiNames.Support, (token, subject, comment, user) => {
  const data = {};
  data.ticket = {
    subject,
    comment,
    user,
    application: "Financial Navigation"
  };
  return {
    method: "POST",
    url: `${SERVER_URL}${API_VERSION_1}support/create-ticket`,
    headers: authHeader(token),
    data
  };
});

addAuth(ApiNames.NotificationPreferences, (token) => ({
  method: "GET",
  url: `${SERVER_URL}${API_VERSION_1}notification-preferences`,
  headers: authHeader(token)
}));

addAuth(ApiNames.UpdateNotificationPreferences, (token, preferenceType, targetId, notificationType, isEnabled) => ({
  method: "PUT",
  url: `${SERVER_URL}${API_VERSION_1}notification-preferences`,
  headers: authHeader(token),
  data: {
    preferenceType,
    targetId,
    notificationType,
    isEnabled
  }
}));

const getLoginImagesAPI = () =>
  axios({
    method: "GET",
    url: `${SERVER_URL}${API_VERSION_1}app/login-images/frontend`
  });

const searchDiagnosisIcdsAPI = (text) =>
  axiosWithAuthentication({
    method: "GET",
    url: `${SERVER_URL}${API_VERSION_1}custom-dropdown/?searchType=diagnosisCode&query=${text}`
  });

const searchDiagnosisNamesAPI = (text) =>
  axiosWithAuthentication({
    method: "GET",
    url: `${SERVER_URL}${API_VERSION_1}custom-dropdown/?searchType=diagnosisName&query=${text}`
  });

const searchRxnormDrugsAPI = (text) =>
  axiosWithAuthentication({
    method: "GET",
    url: `${SERVER_URL}${API_VERSION_1}rxnorm-drug/search?query=${text}`
  });

const api = (name) => fetch(ApiMap[name])(name);

export {
  api,
  ApiNames,
  ApiMap,
  ApiCallerMap,
  CallerType,
  Environment,
  getLoginImagesAPI,
  searchDiagnosisIcdsAPI,
  searchDiagnosisNamesAPI,
  searchRxnormDrugsAPI
};
